import React from "react";

const SectionHeader = ({ heading, className }) => {
  return (
    heading && (
      <div className={" my-5 mx-auto " + className}>
        <h2 className="text-lg md:text-4xl  font-bold relative py-3 pr-16 after:absolute after:bottom-0 after:left-0 inline-block after:w-full after:h-1 after:bg-gradient-to-r after:from-orange-500 after:to-transparent">
          {heading}
        </h2>
      </div>
    )
  );
};

export default SectionHeader;
